<template>
  <v-container
    id="abstract"
    fluid
    container
    class="py-0 fill-height">
    <!-- the organization selection -->
    <v-row
        v-if="showRegistration"
        align="center"
        justify="center">
        <v-col
          cols="12"
          xs="8"
          sm="8"
          md="6"
          lg="4"
          xl="3">
          <v-card tile class="elevation-8 mx-8">
            <v-card tile flat class="px-6 py-6">
              <v-card-title class="layout justify-center pt-8 pb-2 mt-0" >
                <h1 class="text--center font-weight-bold" style="color:#339966; font-size:0.84em;"> Your Organization </h1>
              </v-card-title>
              <v-form>
              <v-layout row justify-center align-center>
              <v-icon
                id="icon"
                color="#339966"
                size="64"
                transition="scale-transition"
                class="mb-4">
                mdi-charity
              </v-icon>
              </v-layout>
              <v-autocomplete
                label="HIS Partner"
                color="#339966"
                prepend-icon="mdi-strategy"
                :items="userTypeItems"
                :item-text="item=>item.name"
                return-object
                :menu-props="{ nudgeBottom: 46, nudgeRight: 60 }"
                @change="selectedUserType "/>
              <v-flex>
                <v-card-actions id="btn-group" dense class="pb-10" width="100%">
                  <v-btn @click="goToLogin()" class="px-12 text-none" color="#339966" tile dark style="font-size: 0.84em;">Cancel</v-btn>
                  <v-btn @click="register()" class="px-12 text-none" color="#339966" tile dark style="font-size: 0.84em;">Submit</v-btn>
                </v-card-actions>
              </v-flex>
              </v-form>
            </v-card>
          </v-card>
        </v-col>
    </v-row>
    <!-- the snackbar -->
    <v-snackbar
        id="snackbar"
        color="#339966"
        v-model="snackbar"
        class="mb-6">
        <v-layout class="pa-2">
          <span name="app" dark style="font-size: 0.84em;"><v-icon color="white"> {{snackbarError.icon}}</v-icon> {{snackbarError.label}}  </span>
          <v-spacer/>
        </v-layout>
    </v-snackbar>
    <!-- the authentication modal -->
    <template>
        <v-dialog
          transition="dialog-bottom-transition"
          v-model="dialog"
          persistent
          scrollable
          max-width="840"
        >
          <v-card tile>
              <v-flex class="ml-2 mr-2 ">
              <v-progress-linear
                color="#339966"
                height="4"
                indeterminate
                :active="loading"/>
              </v-flex>
            <v-card-title class="subtitle-1 grey lighten-5">
              <v-icon color="red" class="mr-1">mdi-shield-lock-outline</v-icon>
              Authentication
            </v-card-title>
            <v-list class="mb-4">
              <v-list-item>
                <v-spacer/>
                <v-list-item-content>
                  <v-list-item-subtitle class="text-wrap caption">Please wait, authentication is in progress...</v-list-item-subtitle>
                </v-list-item-content>
                <v-spacer/>
              </v-list-item>
            </v-list>
            <!-- <v-card-actions class=" grey lighten-5">
              <v-spacer></v-spacer>
              <v-btn
                dark
                text
                small
                color="green darken-1"
                @click="closeInitDialog"
                class="mb-2"
              >
                I Agree
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
    </template>
  </v-container>
</template>

<script>

export default {
  computed: {
    size () {
      const size = { xs: 'x-small', sm: 'small', lg: 'large', xl: 'x-large' }[this.$vuetify.breakpoint.name]
      return size ? { [size]: true } : {}
    }
  },
  data: () => {
    return {
      dialog: true,
      showRegistration: false,
      thisTermsDialog: false,
      snack: true,
      loading: true,
      username: null,
      password: null,
      snackbar: false,
      show: false,
      userData: null,
      userTypeItems: [],
      accessToken: null,
      refreshToken: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('Email and passwor do not match')
      },
      emailError: { icon: 'mdi-server-security', label: 'You have submitted an invalid email!' },
      usernameError: { icon: 'mdi-server-security', label: 'You cannot sign in with an empty email!' },
      passwordError: { icon: 'mdi-server-security', label: 'You cannot sign in with an empty password!' },
      usernamePasswordError: { icon: 'mdi-server-security', label: 'You cannot sign in with an empty email and password!' },
      snackbarError: { icon: 'mdi-server-security', label: 'Failed to sign in, please verify your username & password!' },
      userError: { icon: 'mdi-server-security', label: 'Authentication failed, redirecting you to the login page.' },
      networkError: { icon: 'mdi-server-network-off', label: 'Authentication failed, redirecting you to the login page.' },
      invalidCredentials: { icon: 'mdi-server-network-off', label: 'Invalid username or password.' }
    }
  },
  methods: {
    // select the user type id
    selectedUserType (item) {
      this.selectedUserTypeId = item.id
    },
    // get the user types that are not attached to a particular user group
    getAllUnexclusiveUsertypes () {
      window.axios.get('/userType/findAllNotExclusive')
        .then((response) => {
          // eslint-disable-next-line
          this.userTypeItems = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    },
    // get the token and refresh token
    getTokens () {
      this.accessToken = this.$route.query.token
      this.refreshToken = this.$route.query.refreshToken
      // console.log(token, refreshToken, '<--------')
      this.loginDecoder(this.accessToken, this.refreshToken)
    },
    // logs the user in after a successful keycloak login
    loginDecoder (token, refreshToken) {
      // login decoder
      window.axios.post('/user/loginDecoder', { token: token, refreshToken: refreshToken })
        .then((response) => {
          if (response.data.length === 0) {
            this.snackbarError = this.userError
            this.snackbar = true
            setTimeout(() => {
              this.$router.push('/login')
            }, 4000)
          } else {
            // valid non user log into the user part of the system
            const id = response.data[0].id
            const userTypeId = response.data[0].user_type_id
            const status = response.data[0].status
            const token = response.data[1]
            const keycloak = response.data[0].keycloak

            if (status === 'Blocked') {
              this.snackbarError = { icon: 'mdi-server-security', label: 'You cannot login, your account has been blocked' }
              this.snackbar = true
            } else if (status === 'Deactivated') {
              this.snackbarError = { icon: 'mdi-server-security', label: 'You cannot login, your account has been deactivated' }
              this.snackbar = true
            } else {
              window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
              // this.loading = false
              const passphrase = process.env.VUE_APP_PASSPHRASE
              // encrypting the data now
              const encryptedText = this.CryptoJS.AES.encrypt(token, passphrase).toString()
              localStorage.setItem('kwkk', id)
              localStorage.setItem('utp', userTypeId)
              localStorage.setItem('token', encryptedText)
              localStorage.setItem('keycloak', JSON.stringify(keycloak))

              // the employee is available
              if (id !== undefined && id !== null) {
                window.axios.post('/signin/signin', { userId: id })
                  .then(async () => {
                    this.loading = false
                    this.$router.push('/userHome')
                  })
                  // eslint-disable-next-line handle-callback-err
                  .catch(() => {
                    this.$router.push('/login')
                  })
                } else {
                  // console.log('not available', response.data)
                  const data = response.data[0]
                  const userTypeId = data.user_type_id

                  // // show the dialog if the user type id is null
                  if (userTypeId === null) {
                    this.snackbar = false
                    this.dialog = false

                    // show the registration modal
                    this.showRegistration = true

                    // setup the user data
                    this.userData = data
                  }
                }
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
          // console.log(error)
          this.loading = false
          this.snackbarError = this.networkError
          this.snackbar = true
          setTimeout(() => {
            this.$router.push('/login')
          }, 4000)
        })
    },
    closeInitDialog () {
      this.dialog = false
    },
    termsDialog () {
      this.thisTermsDialog = true
    },
    signin () {
      this.loading = true
      if (this.username == null || this.password == null || this.username === '' || this.password === '' || this.username.length === 0 || this.username.length < 4 || this.password.length === 0) {
        if ((this.username == null || this.username.trim() === '') && (this.password == null || this.password.trim() === '')) {
          this.snackbarError = this.usernamePasswordError
          this.snackbar = true
          this.loading = false
        } else if (this.username == null || this.username.trim() === '') {
          this.snackbarError = this.usernameError
          this.snackbar = true
          this.loading = false
        } else if (this.password == null || this.password.trim() === '') {
          this.snackbarError = this.passwordError
          this.snackbar = true
          this.loading = false
        } else {
          this.snackbarError = this.invalidCredentials
          this.snackbar = true
          this.loading = false
        }
        this.loading = false
      } else {
        window.axios.post('/admin/login', { username: this.username, password: this.password })
          .then((response) => {
            // eslint-disable-next-line
            if (response.data.length === 0) {
              // login
              window.axios.post('/user/login', { username: this.username, password: this.password })
                .then((response) => {
                  this.loading = false
                  if (response.data.length === 0) {
                    this.snackbarError = this.userError
                    this.snackbar = true
                  } else {
                    // valid non user log into the user part of the system
                    const id = response.data[0].id
                    const userTypeId = response.data[0].user_type_id
                    const status = response.data[0].status
                    const token = response.data[1]

                    if (status === 'Blocked') {
                      this.snackbarError = { icon: 'mdi-server-security', label: 'You cannot login, your account has been blocked' }
                      this.snackbar = true
                    } else if (status === 'Deactivated') {
                      this.snackbarError = { icon: 'mdi-server-security', label: 'You cannot login, your account has been deactivated' }
                      this.snackbar = true
                    } else {
                      window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
                      // this.loading = false
                      const passphrase = process.env.VUE_APP_PASSPHRASE
                      // encrypting the data now
                      const encryptedText = this.CryptoJS.AES.encrypt(token, passphrase).toString()
                      localStorage.setItem('kwkk', id)
                      localStorage.setItem('utp', userTypeId)
                      localStorage.setItem('token', encryptedText)

                      window.axios.post('/signin/signin', { userId: id })
                        .then(async () => {
                          this.loading = false
                          this.$router.push('/userHome')
                        })
                        // eslint-disable-next-line handle-callback-err
                        .catch(() => {
                        })
                    }
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(() => {
                  // console.log(error)
                  this.loading = false
                  this.snackbarError = this.networkError
                  this.snackbar = true
                })
            } else {
              // go to the admin login
              const id = response.data[0].id
              const token = response.data[1]

              window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
              // getting the encryption passphrase
              this.loading = false
              const passphrase = process.env.VUE_APP_PASSPHRASE
              // encrypting the data now
              const encryptedText = this.CryptoJS.AES.encrypt(token, passphrase).toString()
              localStorage.setItem('kwkk', id)
              localStorage.setItem('token', encryptedText)
              this.$router.push('/home')
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(() => {
            // console.log(error)
            this.loading = false
            this.snackbarError = this.networkError
            this.snackbar = true
          })
      }
    },
    register () {
      // show the loading dialog
      this.dialog = true
      this.loading = true
      
      // dismiss the registration dialog
      this.showRegistration = false
      
      const data = this.userData
      window.axios.post('/user/insertByKeycloak', { firstname: data.firstname, surname: data.surname, email: data.email, phone: data.phone, password: null, userTypeId: this.selectedUserTypeId })
      .then((response) => {
          // eslint-disable-next-line
          this.loading = false
          var affectedRows = response.data.affectedRows
          if (affectedRows === 1) {
            // decode the login
            this.loginDecoder(this.accessToken, this.refreshToken)
          } else {
            var message = response.data.message
            this.snackbarError = { icon: 'mdi-server-security', label: message }
            this.snackbar = true
            this.$router.push('/login')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
          this.$router.push('/login')
        })
    },
    goToLogin () {
      this.$router.push('/login')
    }
  },
  mounted: [
    function () {
      // get the user types
      this.getAllUnexclusiveUsertypes()
      // gets the token and the refresh token
      this.getTokens()
    }
  ]
}
</script>

<style scoped>
.v-text-field >>> input {
  font-size: 0.84em;
}
.v-text-field >>> label {
  font-size: 0.84em;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  /* #abstract{
    background-size: cover;
    background: url("../assets/abstract.svg");
    background-repeat: no-repeat;
    width: 100%;
  } */
  #logo{
    padding-top: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  #btn-group{
    justify-content: center;
  }
  #forgot-text{
    text-decoration: underline;
  }
  a:link, a:visited {
    color: black;
    text-align: center;
    text-decoration: none;
    display: inline-block;
  }
  a:hover, a:active {
    color: #339966;
  }
}
#abstract{
  background-size: cover;
  background: url("../assets/wave.svg");
  background-repeat: no-repeat;
  background-position: center;
  /* width: 100%; */
}
#logo{
  padding-top: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
#btn-group{
  justify-content: center;
}
#forgot-text{
  text-decoration: underline;
}
a:link, a:visited {
  color: black;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
a:hover, a:active {
  color: #339966;
}
</style>
